import { render, staticRenderFns } from "./CreditNoteForm.vue?vue&type=template&id=ecc20248&"
import script from "./CreditNoteForm.vue?vue&type=script&lang=js&"
export * from "./CreditNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports